// extracted by mini-css-extract-plugin
export default {"listContainer":"Seizures_listContainer__r46ve"};